<script setup lang="ts">
    import { defaultRepeaterConverter } from "@/components/forms/groups/Repeater/helpers";
    import { getConfig, klinikenApi } from "@/api";
    import { openDialog } from "@/utils";
    import { convertHjalpmedelData } from "@/components/forms/reusables/hjalpmedelHelper";

    withDefaults(defineProps<{ directionUpwards?: boolean }>(), {
        /**
         * KAutocomplete-props
         */
        directionUpwards: false,
    });
    const fetchHjalpmedel = async () => {
        try {
            const response = await klinikenApi.get("/operation/kodverk/hjalpmedel/", getConfig());
            return response.data.results.map((item: any) => convertHjalpmedelData({ hjalpmedel: item }));
        } catch (error) {
            console.error(error);
            openDialog("Kunde inte hämta hjälpmedel.", "warning");
        }
    };
</script>

<template>
    <KRepeater
        name="hjalpmedel"
        add-label="Lägg till hjälpmedel"
        remove-label="Ta bort hjälpmedel"
        :converter="defaultRepeaterConverter"
        #default="{ index, model }"
    >
        <KAutocomplete
            name="id"
            :options="fetchHjalpmedel"
            :direction="directionUpwards ? 'up' : 'default'"
            label="Hjälpmedel"
            :value="model?.[index]?.id ?? null"
            class="span-all"
        />
    </KRepeater>
</template>

<style scoped lang="scss"></style>
